/**
 * Stickers whose printed POS table id is wrong, keyed by establishment, then by the printed id.
 *
 * A sticker's URL carries the POS table id it was printed from (`pId`), and nothing after
 * printing can change it. Rumor's Winnipeg (establishment 127) had its "Table 2" and "Table 4"
 * stickers printed from each other's POS table, because the POS held the two tables' names
 * swapped when the QR side imported them: a guest at table 2 scanned and saw table 4's bill
 * (Oct 2026). The stickers stay as printed and the database link stays as printed; the two ids
 * are corrected here, for these two stickers only. Every other sticker anywhere passes through
 * untouched.
 */
const PRINTED_POS_TABLE_ALIASES: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  // Rumor's Winnipeg: the "Table 2" sticker carries POS table 110, which the POS numbers 4;
  // the "Table 4" sticker carries 112, which the POS numbers 2.
  '127': { '110': '112', '112': '110' },
}

/**
 * The POS table a sticker really stands for. Only for an id read straight off the sticker's
 * URL: a value already resolved and kept in session storage must not go through this again.
 */
export function resolvePrintedPosTableId(
  establishmentId: string | null | undefined,
  printedPosTableId: string | null | undefined
): string | null | undefined {
  if (!establishmentId || !printedPosTableId) return printedPosTableId
  const aliases = PRINTED_POS_TABLE_ALIASES[establishmentId]
  return aliases?.[printedPosTableId] ?? printedPosTableId
}
